package com.milta.feature.importjobs.data.repository

import com.milta.feature.importjobs.data.remote.ImportJobsApi
import com.milta.feature.importjobs.data.remote.dto.toDomain
import com.milta.feature.importjobs.domain.entity.ImportJob
import com.milta.feature.importjobs.domain.entity.ImportJobFlow
import com.milta.feature.importjobs.domain.repository.ImportJobRepository

class ImportJobRepositoryImpl(private val api: ImportJobsApi) : ImportJobRepository {
    override suspend fun submit(
        flow: ImportJobFlow,
        fileBytes: ByteArray,
        fileName: String,
        routeId: String?,
        onUpload: (sentBytes: Long, totalBytes: Long) -> Unit,
    ): ImportJob = api.submit(flow, fileBytes, fileName, routeId, onUpload).toDomain()

    override suspend fun get(id: String): ImportJob = api.get(id).toDomain()

    override suspend fun listActive(): List<ImportJob> = api.listActive().map { it.toDomain() }

    override suspend fun retry(flow: ImportJobFlow, id: String): ImportJob = api.retry(flow, id).toDomain()

    override suspend fun cancel(id: String): ImportJob = api.cancel(id).toDomain()

    override suspend fun acknowledge(id: String) = api.acknowledge(id)
}
